import { useEffect, useState } from 'react';
import { fleetService, maintenanceService } from '../../services/firestore';
import { onRtaPages } from '../../services/fleetStatus';
import logger from '../../utils/logger';

/*
 * The fleet of the Government Transactions page, read once for all its tabs (owner, 18 Oct 2026: one page with
 * tabs). It gives each tab the list it read on its own before:
 *  - letterCars: the letter tabs (Vehicle Export, Hiaza, Mulkiya, Custom Document) - the RTA-page cars with the km
 *    of the status map; empty when either read fails, as before.
 *  - rtaCars: Sales Invoice - the RTA-page cars as read; empty only when the fleet read fails, as before.
 */
export async function loadGovFleet() {
    const [carsRead, statusRead] = await Promise.allSettled([
        fleetService.getAllCars(false),
        maintenanceService.getStatusMap()
    ]);
    if (carsRead.status === 'rejected') {
        logger.error("Failed to load fleet", carsRead.reason);
        return { rtaCars: [], letterCars: [] };
    }
    const data = carsRead.value;
    if (!data) return { rtaCars: [], letterCars: [] };

    // an RTA page: Ready To Sell stays (still registered); a car RTA dropped goes
    const rtaCars = data.filter(onRtaPages);
    if (statusRead.status === 'rejected') {
        logger.error("Failed to load fleet", statusRead.reason);
        return { rtaCars, letterCars: [] };
    }
    const statusResult = statusRead.value;
    const statusMap = (statusResult && statusResult.map) || statusResult || {};
    const letterCars = data
        .map(car => ({
            ...car,
            current_km: statusMap[car.plate_number]?.km || car.current_km || 0
        }))
        .filter(onRtaPages);
    return { rtaCars, letterCars };
}

export function useGovFleet() {
    const [fleet, setFleet] = useState({ loading: true, rtaCars: [], letterCars: [] });
    useEffect(() => {
        let live = true;
        loadGovFleet().then((cars) => { if (live) setFleet({ loading: false, ...cars }); });
        return () => { live = false; };
    }, []);
    return fleet;
}
